import { Container, Typography, Paper, Box } from "@mui/material";
import { useStore } from "../../app/stores/store";

export default function ServerError() {
    const commonStore = useStore((s) => s.commonStore);
    return (
        <Container maxWidth="md" sx={{ mt: 6 }}>
            <Paper sx={{ p: 4 }}>
                <Typography variant="h4" color="error" gutterBottom>
                    Server Error
                </Typography>
                {commonStore.error?.message && (
                    <Typography variant="h6" color="error" gutterBottom>
                        {commonStore.error.message}
                    </Typography>
                )}
                {commonStore.error?.details && (
                    <Box sx={{ mt: 2 }}>
                        <Typography variant="subtitle1" color="primary" gutterBottom>
                            Stack trace
                        </Typography>
                        <Box sx={{ bgcolor: "#f5f5f5", p: 2, borderRadius: 1, fontFamily: "monospace", fontSize: 14 }}>
                            <code>{commonStore.error.details}</code>
                        </Box>
                    </Box>
                )}
            </Paper>
        </Container>
    )
}